import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthState } from 'src/app/store/auth/auth.reducer';
import { actionPasswordResetSubmit } from 'src/app/store/auth/auth.actions';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordResetComponent implements OnInit {
  @ViewChild('passwordResetForm', { static: true }) passwordResetForm: NgForm;

  form = new UntypedFormGroup({
    email: new UntypedFormControl(''),
    password: new UntypedFormControl(''),
    passwordConfirm: new UntypedFormControl('')
  });

  formState = this.store.select(store => store.auth.passwordResetForm);
  localError: string | false;
  token = this.route.snapshot.params['token'];

  constructor(private route: ActivatedRoute, private store: Store<{ auth: AuthState }>) {}

  ngOnInit() {}

  submit() {
    if (this.form.value.password !== this.form.value.passwordConfirm) {
      this.localError = `The passwords don't match.`;
      return;
    }
    this.localError = false;
    this.store.dispatch(
      actionPasswordResetSubmit({
        email: this.form.value.email,
        password: this.form.value.password,
        token: this.token
      })
    );
  }
}
